/**
 * Generated by orval v8.12.2 🍺
 * Do not edit manually.
 * PEXIFY Backend
 * PEXIFY operating system backend — privately governed commerce ecosystem. M3 başlangıcı: FastAPI shell. Faz 1-6 schema RATIFIED; per-component CRUD + RBAC + audit emit + engines (M-AUDIT / M-WALLET / M-POLICY / M-NOTIF) coming.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  RemoteAccessErrorResponse,
  RemoteAssignmentPolicyRead,
  RemoteAssignmentPolicyWrite,
  RemoteBoardStoreLabelsRead,
  RemoteBoardStoresRead,
  RemoteGatewayResultAck,
  RemoteGatewayResultReport,
  RemoteHostListResponse,
  RemoteHostOwnerWrite,
  RemoteHostRead,
  RemoteLaunchIntent,
  RemoteLaunchReplayResponse,
  RemoteLaunchTicketConsumeRequest,
  RemoteLaunchTicketConsumeResponse,
  RemoteLinkableStoresRead,
  RemoteReconcileRequest,
  RemoteReconcileResponse,
  RemoteSelectedAssignmentsRead,
  RemoteSelectedAssignmentsWrite,
  RemoteSellerOrgsRead,
  RemoteSessionCloseRequest,
  RemoteSessionRead,
  RemoteStoreLabelRead,
  RemoteStoreLabelWrite,
  RemoteStoreLabelsRead,
  RemoteStoreLinkRead,
  RemoteStoreLinkWrite,
  RemoteStoreLinksRead,
  RemoteTakeoverDecisionAck,
  RemoteTakeoverOperatorDecision,
  RemoteTakeoverOperatorReject,
  RemoteTakeoverWarning,
  StoreProductGroupRead,
  StoreProductGroupWrite,
  StoreProductGroupsRead
} from '../model';

import { orvalClient } from '../../orval-client';




export type createAdminRemoteAssignmentPolicyResponse201 = {
  data: RemoteAssignmentPolicyRead
  status: 201
}

export type createAdminRemoteAssignmentPolicyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createAdminRemoteAssignmentPolicyResponseSuccess = (createAdminRemoteAssignmentPolicyResponse201) & {
  headers: Headers;
};
export type createAdminRemoteAssignmentPolicyResponseError = (createAdminRemoteAssignmentPolicyResponse422) & {
  headers: Headers;
};

export type createAdminRemoteAssignmentPolicyResponse = (createAdminRemoteAssignmentPolicyResponseSuccess | createAdminRemoteAssignmentPolicyResponseError)

export const getCreateAdminRemoteAssignmentPolicyUrl = () => {




  return `/api/v1/admin/remote-access/assignment-policies`
}

/**
 * @summary Create Assignment Policy
 */
export const createAdminRemoteAssignmentPolicy = async (remoteAssignmentPolicyWrite: RemoteAssignmentPolicyWrite, options?: RequestInit): Promise<createAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<createAdminRemoteAssignmentPolicyResponse>(getCreateAdminRemoteAssignmentPolicyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteAssignmentPolicyWrite)
  }
);}




export const getCreateAdminRemoteAssignmentPolicyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext> => {

const mutationKey = ['createAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, {data: RemoteAssignmentPolicyWrite}> = (props) => {
          const {data} = props ?? {};

          return  createAdminRemoteAssignmentPolicy(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>>
    export type CreateAdminRemoteAssignmentPolicyMutationBody = RemoteAssignmentPolicyWrite
    export type CreateAdminRemoteAssignmentPolicyMutationError = HTTPValidationError

    /**
 * @summary Create Assignment Policy
 */
export const useCreateAdminRemoteAssignmentPolicy = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>, TError,{data: RemoteAssignmentPolicyWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRemoteAssignmentPolicy>>,
        TError,
        {data: RemoteAssignmentPolicyWrite},
        TContext
      > => {
      return useMutation(getCreateAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type revokeAdminRemoteAssignmentPolicyResponse200 = {
  data: RemoteAssignmentPolicyRead
  status: 200
}

export type revokeAdminRemoteAssignmentPolicyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type revokeAdminRemoteAssignmentPolicyResponseSuccess = (revokeAdminRemoteAssignmentPolicyResponse200) & {
  headers: Headers;
};
export type revokeAdminRemoteAssignmentPolicyResponseError = (revokeAdminRemoteAssignmentPolicyResponse422) & {
  headers: Headers;
};

export type revokeAdminRemoteAssignmentPolicyResponse = (revokeAdminRemoteAssignmentPolicyResponseSuccess | revokeAdminRemoteAssignmentPolicyResponseError)

export const getRevokeAdminRemoteAssignmentPolicyUrl = (policyId: string,) => {




  return `/api/v1/admin/remote-access/assignment-policies/${policyId}`
}

/**
 * @summary Revoke Assignment Policy
 */
export const revokeAdminRemoteAssignmentPolicy = async (policyId: string, options?: RequestInit): Promise<revokeAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<revokeAdminRemoteAssignmentPolicyResponse>(getRevokeAdminRemoteAssignmentPolicyUrl(policyId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRevokeAdminRemoteAssignmentPolicyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext> => {

const mutationKey = ['revokeAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, {policyId: string}> = (props) => {
          const {policyId} = props ?? {};

          return  revokeAdminRemoteAssignmentPolicy(policyId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>>

    export type RevokeAdminRemoteAssignmentPolicyMutationError = HTTPValidationError

    /**
 * @summary Revoke Assignment Policy
 */
export const useRevokeAdminRemoteAssignmentPolicy = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>, TError,{policyId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof revokeAdminRemoteAssignmentPolicy>>,
        TError,
        {policyId: string},
        TContext
      > => {
      return useMutation(getRevokeAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type amendAdminRemoteAssignmentPolicyResponse200 = {
  data: RemoteAssignmentPolicyRead
  status: 200
}

export type amendAdminRemoteAssignmentPolicyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type amendAdminRemoteAssignmentPolicyResponseSuccess = (amendAdminRemoteAssignmentPolicyResponse200) & {
  headers: Headers;
};
export type amendAdminRemoteAssignmentPolicyResponseError = (amendAdminRemoteAssignmentPolicyResponse422) & {
  headers: Headers;
};

export type amendAdminRemoteAssignmentPolicyResponse = (amendAdminRemoteAssignmentPolicyResponseSuccess | amendAdminRemoteAssignmentPolicyResponseError)

export const getAmendAdminRemoteAssignmentPolicyUrl = (policyId: string,) => {




  return `/api/v1/admin/remote-access/assignment-policies/${policyId}`
}

/**
 * @summary Amend Assignment Policy
 */
export const amendAdminRemoteAssignmentPolicy = async (policyId: string,
    remoteAssignmentPolicyWrite: RemoteAssignmentPolicyWrite, options?: RequestInit): Promise<amendAdminRemoteAssignmentPolicyResponse> => {

  return orvalClient<amendAdminRemoteAssignmentPolicyResponse>(getAmendAdminRemoteAssignmentPolicyUrl(policyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteAssignmentPolicyWrite)
  }
);}




export const getAmendAdminRemoteAssignmentPolicyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext> => {

const mutationKey = ['amendAdminRemoteAssignmentPolicy'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, {policyId: string;data: RemoteAssignmentPolicyWrite}> = (props) => {
          const {policyId,data} = props ?? {};

          return  amendAdminRemoteAssignmentPolicy(policyId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmendAdminRemoteAssignmentPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>>
    export type AmendAdminRemoteAssignmentPolicyMutationBody = RemoteAssignmentPolicyWrite
    export type AmendAdminRemoteAssignmentPolicyMutationError = HTTPValidationError

    /**
 * @summary Amend Assignment Policy
 */
export const useAmendAdminRemoteAssignmentPolicy = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>, TError,{policyId: string;data: RemoteAssignmentPolicyWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof amendAdminRemoteAssignmentPolicy>>,
        TError,
        {policyId: string;data: RemoteAssignmentPolicyWrite},
        TContext
      > => {
      return useMutation(getAmendAdminRemoteAssignmentPolicyMutationOptions(options), queryClient);
    }
    export type getAdminRemoteSelectedAssignmentsResponse200 = {
  data: RemoteSelectedAssignmentsRead
  status: 200
}

export type getAdminRemoteSelectedAssignmentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getAdminRemoteSelectedAssignmentsResponseSuccess = (getAdminRemoteSelectedAssignmentsResponse200) & {
  headers: Headers;
};
export type getAdminRemoteSelectedAssignmentsResponseError = (getAdminRemoteSelectedAssignmentsResponse422) & {
  headers: Headers;
};

export type getAdminRemoteSelectedAssignmentsResponse = (getAdminRemoteSelectedAssignmentsResponseSuccess | getAdminRemoteSelectedAssignmentsResponseError)

export const getGetAdminRemoteSelectedAssignmentsUrl = (membershipId: string,) => {




  return `/api/v1/admin/remote-access/assignments/${membershipId}`
}

/**
 * @summary Get Selected Assignments
 */
export const getAdminRemoteSelectedAssignments = async (membershipId: string, options?: RequestInit): Promise<getAdminRemoteSelectedAssignmentsResponse> => {

  return orvalClient<getAdminRemoteSelectedAssignmentsResponse>(getGetAdminRemoteSelectedAssignmentsUrl(membershipId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRemoteSelectedAssignmentsQueryKey = (membershipId: string,) => {
    return [
    `/api/v1/admin/remote-access/assignments/${membershipId}`
    ] as const;
    }


export const getGetAdminRemoteSelectedAssignmentsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = HTTPValidationError>(membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRemoteSelectedAssignmentsQueryKey(membershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>> = ({ signal }) => getAdminRemoteSelectedAssignments(membershipId, { signal });





   return  { queryKey, queryFn, enabled: membershipId !== null && membershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRemoteSelectedAssignmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>>
export type GetAdminRemoteSelectedAssignmentsQueryError = HTTPValidationError


export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = HTTPValidationError>(
 membershipId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = HTTPValidationError>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = HTTPValidationError>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Selected Assignments
 */

export function useGetAdminRemoteSelectedAssignments<TData = Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError = HTTPValidationError>(
 membershipId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSelectedAssignments>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRemoteSelectedAssignmentsQueryOptions(membershipId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type replaceAdminRemoteSelectedAssignmentsResponse200 = {
  data: RemoteSelectedAssignmentsRead
  status: 200
}

export type replaceAdminRemoteSelectedAssignmentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type replaceAdminRemoteSelectedAssignmentsResponseSuccess = (replaceAdminRemoteSelectedAssignmentsResponse200) & {
  headers: Headers;
};
export type replaceAdminRemoteSelectedAssignmentsResponseError = (replaceAdminRemoteSelectedAssignmentsResponse422) & {
  headers: Headers;
};

export type replaceAdminRemoteSelectedAssignmentsResponse = (replaceAdminRemoteSelectedAssignmentsResponseSuccess | replaceAdminRemoteSelectedAssignmentsResponseError)

export const getReplaceAdminRemoteSelectedAssignmentsUrl = (membershipId: string,) => {




  return `/api/v1/admin/remote-access/assignments/${membershipId}`
}

/**
 * @summary Replace Selected Assignments
 */
export const replaceAdminRemoteSelectedAssignments = async (membershipId: string,
    remoteSelectedAssignmentsWrite: RemoteSelectedAssignmentsWrite, options?: RequestInit): Promise<replaceAdminRemoteSelectedAssignmentsResponse> => {

  return orvalClient<replaceAdminRemoteSelectedAssignmentsResponse>(getReplaceAdminRemoteSelectedAssignmentsUrl(membershipId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSelectedAssignmentsWrite)
  }
);}




export const getReplaceAdminRemoteSelectedAssignmentsMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext> => {

const mutationKey = ['replaceAdminRemoteSelectedAssignments'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, {membershipId: string;data: RemoteSelectedAssignmentsWrite}> = (props) => {
          const {membershipId,data} = props ?? {};

          return  replaceAdminRemoteSelectedAssignments(membershipId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceAdminRemoteSelectedAssignmentsMutationResult = NonNullable<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>>
    export type ReplaceAdminRemoteSelectedAssignmentsMutationBody = RemoteSelectedAssignmentsWrite
    export type ReplaceAdminRemoteSelectedAssignmentsMutationError = HTTPValidationError

    /**
 * @summary Replace Selected Assignments
 */
export const useReplaceAdminRemoteSelectedAssignments = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>, TError,{membershipId: string;data: RemoteSelectedAssignmentsWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceAdminRemoteSelectedAssignments>>,
        TError,
        {membershipId: string;data: RemoteSelectedAssignmentsWrite},
        TContext
      > => {
      return useMutation(getReplaceAdminRemoteSelectedAssignmentsMutationOptions(options), queryClient);
    }
    export type listAdminRemoteBoardStoreLabelsResponse200 = {
  data: RemoteBoardStoreLabelsRead
  status: 200
}

export type listAdminRemoteBoardStoreLabelsResponseSuccess = (listAdminRemoteBoardStoreLabelsResponse200) & {
  headers: Headers;
};
;

export type listAdminRemoteBoardStoreLabelsResponse = (listAdminRemoteBoardStoreLabelsResponseSuccess)

export const getListAdminRemoteBoardStoreLabelsUrl = () => {




  return `/api/v1/admin/remote-access/host-store-labels`
}

/**
 * Every reachable machine's live manual store names in one read.
 * @summary List Remote Board Store Labels
 */
export const listAdminRemoteBoardStoreLabels = async ( options?: RequestInit): Promise<listAdminRemoteBoardStoreLabelsResponse> => {

  return orvalClient<listAdminRemoteBoardStoreLabelsResponse>(getListAdminRemoteBoardStoreLabelsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteBoardStoreLabelsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/host-store-labels`
    ] as const;
    }


export const getListAdminRemoteBoardStoreLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteBoardStoreLabelsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>> = ({ signal }) => listAdminRemoteBoardStoreLabels({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteBoardStoreLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>>
export type ListAdminRemoteBoardStoreLabelsQueryError = unknown


export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Board Store Labels
 */

export function useListAdminRemoteBoardStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteBoardStoreLabelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminRemoteBoardStoresResponse200 = {
  data: RemoteBoardStoresRead
  status: 200
}

export type listAdminRemoteBoardStoresResponseSuccess = (listAdminRemoteBoardStoresResponse200) & {
  headers: Headers;
};
;

export type listAdminRemoteBoardStoresResponse = (listAdminRemoteBoardStoresResponseSuccess)

export const getListAdminRemoteBoardStoresUrl = () => {




  return `/api/v1/admin/remote-access/host-stores`
}

/**
 * Every reachable machine's live store links, in one read.
 *
 * The board names the stores under each machine, so asking per machine would
 * cost one request per tile on every load and every refresh. Machines with no
 * links are returned with an empty list rather than omitted, so the caller can
 * tell "none linked" apart from "not asked about".
 * @summary List Remote Board Stores
 */
export const listAdminRemoteBoardStores = async ( options?: RequestInit): Promise<listAdminRemoteBoardStoresResponse> => {

  return orvalClient<listAdminRemoteBoardStoresResponse>(getListAdminRemoteBoardStoresUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteBoardStoresQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/host-stores`
    ] as const;
    }


export const getListAdminRemoteBoardStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteBoardStoresQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>> = ({ signal }) => listAdminRemoteBoardStores({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteBoardStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>>
export type ListAdminRemoteBoardStoresQueryError = unknown


export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteBoardStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Board Stores
 */

export function useListAdminRemoteBoardStores<TData = Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteBoardStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteBoardStoresQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type listAdminRemoteHostsResponse200 = {
  data: RemoteHostListResponse
  status: 200
}

export type listAdminRemoteHostsResponseSuccess = (listAdminRemoteHostsResponse200) & {
  headers: Headers;
};
;

export type listAdminRemoteHostsResponse = (listAdminRemoteHostsResponseSuccess)

export const getListAdminRemoteHostsUrl = () => {




  return `/api/v1/admin/remote-access/hosts`
}

/**
 * @summary List Hosts
 */
export const listAdminRemoteHosts = async ( options?: RequestInit): Promise<listAdminRemoteHostsResponse> => {

  return orvalClient<listAdminRemoteHostsResponse>(getListAdminRemoteHostsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/hosts`
    ] as const;
    }


export const getListAdminRemoteHostsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHosts>>> = ({ signal }) => listAdminRemoteHosts({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHosts>>>
export type ListAdminRemoteHostsQueryError = unknown


export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHosts>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHosts>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Hosts
 */

export function useListAdminRemoteHosts<TData = Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHosts>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type approveAdminRemoteHostResponse200 = {
  data: RemoteHostRead
  status: 200
}

export type approveAdminRemoteHostResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type approveAdminRemoteHostResponseSuccess = (approveAdminRemoteHostResponse200) & {
  headers: Headers;
};
export type approveAdminRemoteHostResponseError = (approveAdminRemoteHostResponse422) & {
  headers: Headers;
};

export type approveAdminRemoteHostResponse = (approveAdminRemoteHostResponseSuccess | approveAdminRemoteHostResponseError)

export const getApproveAdminRemoteHostUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/approve`
}

/**
 * Admit a discovered server into the estate. Grants nobody anything.
 *
 * This is the act that replaced two hand-maintained env lists and two service
 * restarts. It moves the host out of `pending` and into the ordinary lifecycle,
 * where reconciliation decides whether it is actually reachable. Who may use it
 * is still a separate decision, made by assigning it.
 * @summary Approve Host
 */
export const approveAdminRemoteHost = async (remoteHostId: string, options?: RequestInit): Promise<approveAdminRemoteHostResponse> => {

  return orvalClient<approveAdminRemoteHostResponse>(getApproveAdminRemoteHostUrl(remoteHostId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getApproveAdminRemoteHostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext> => {

const mutationKey = ['approveAdminRemoteHost'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdminRemoteHost>>, {remoteHostId: string}> = (props) => {
          const {remoteHostId} = props ?? {};

          return  approveAdminRemoteHost(remoteHostId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdminRemoteHostMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdminRemoteHost>>>

    export type ApproveAdminRemoteHostMutationError = HTTPValidationError

    /**
 * @summary Approve Host
 */
export const useApproveAdminRemoteHost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdminRemoteHost>>, TError,{remoteHostId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAdminRemoteHost>>,
        TError,
        {remoteHostId: string},
        TContext
      > => {
      return useMutation(getApproveAdminRemoteHostMutationOptions(options), queryClient);
    }
    export type createAdminRemoteLaunchResponse200 = {
  data: RemoteLaunchIntent
  status: 200
}

export type createAdminRemoteLaunchResponse409 = {
  data: RemoteLaunchReplayResponse | RemoteAccessErrorResponse
  status: 409
}

export type createAdminRemoteLaunchResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createAdminRemoteLaunchResponseSuccess = (createAdminRemoteLaunchResponse200) & {
  headers: Headers;
};
export type createAdminRemoteLaunchResponseError = (createAdminRemoteLaunchResponse409 | createAdminRemoteLaunchResponse422) & {
  headers: Headers;
};

export type createAdminRemoteLaunchResponse = (createAdminRemoteLaunchResponseSuccess | createAdminRemoteLaunchResponseError)

export const getCreateAdminRemoteLaunchUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/launch`
}

/**
 * @summary Launch Host
 */
export const createAdminRemoteLaunch = async (remoteHostId: string, options?: RequestInit): Promise<createAdminRemoteLaunchResponse> => {

  return orvalClient<createAdminRemoteLaunchResponse>(getCreateAdminRemoteLaunchUrl(remoteHostId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getCreateAdminRemoteLaunchMutationOptions = <TError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext> => {

const mutationKey = ['createAdminRemoteLaunch'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, {remoteHostId: string}> = (props) => {
          const {remoteHostId} = props ?? {};

          return  createAdminRemoteLaunch(remoteHostId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdminRemoteLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof createAdminRemoteLaunch>>>

    export type CreateAdminRemoteLaunchMutationError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError

    /**
 * @summary Launch Host
 */
export const useCreateAdminRemoteLaunch = <TError = RemoteLaunchReplayResponse | RemoteAccessErrorResponse | HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdminRemoteLaunch>>, TError,{remoteHostId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdminRemoteLaunch>>,
        TError,
        {remoteHostId: string},
        TContext
      > => {
      return useMutation(getCreateAdminRemoteLaunchMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostLinkableStoresResponse200 = {
  data: RemoteLinkableStoresRead
  status: 200
}

export type listAdminRemoteHostLinkableStoresResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listAdminRemoteHostLinkableStoresResponseSuccess = (listAdminRemoteHostLinkableStoresResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostLinkableStoresResponseError = (listAdminRemoteHostLinkableStoresResponse422) & {
  headers: Headers;
};

export type listAdminRemoteHostLinkableStoresResponse = (listAdminRemoteHostLinkableStoresResponseSuccess | listAdminRemoteHostLinkableStoresResponseError)

export const getListAdminRemoteHostLinkableStoresUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/linkable-stores`
}

/**
 * Stores the admin may still link, scoped to the org they are acting in.
 *
 * The scope is the acting membership's own organisation — not "the platform
 * owner's", which D-1 forbids reading from ``org_type``. An admin acting for
 * another organisation would see that organisation's stores and no others.
 *
 * A store already recorded on *any* machine is excluded, not just one on this
 * machine, so the board cannot be used to write a record that says a shop is
 * in two places.
 * @summary List Remote Host Linkable Stores
 */
export const listAdminRemoteHostLinkableStores = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostLinkableStoresResponse> => {

  return orvalClient<listAdminRemoteHostLinkableStoresResponse>(getListAdminRemoteHostLinkableStoresUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostLinkableStoresQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/linkable-stores`
    ] as const;
    }


export const getListAdminRemoteHostLinkableStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = HTTPValidationError>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostLinkableStoresQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>> = ({ signal }) => listAdminRemoteHostLinkableStores(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostLinkableStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>>
export type ListAdminRemoteHostLinkableStoresQueryError = HTTPValidationError


export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Host Linkable Stores
 */

export function useListAdminRemoteHostLinkableStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostLinkableStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostLinkableStoresQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type setAdminRemoteHostOwnerResponse200 = {
  data: RemoteHostRead
  status: 200
}

export type setAdminRemoteHostOwnerResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setAdminRemoteHostOwnerResponseSuccess = (setAdminRemoteHostOwnerResponse200) & {
  headers: Headers;
};
export type setAdminRemoteHostOwnerResponseError = (setAdminRemoteHostOwnerResponse422) & {
  headers: Headers;
};

export type setAdminRemoteHostOwnerResponse = (setAdminRemoteHostOwnerResponseSuccess | setAdminRemoteHostOwnerResponseError)

export const getSetAdminRemoteHostOwnerUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/owner`
}

/**
 * Record whose machine this is: ours, a customer's, or a Pexify seller's.
 *
 * Ours and a named customer are display grouping only. Choosing a seller is
 * authority: the seller's owners are given the machine (connect, never
 * takeover) and any other seller's members lose it, so the write takes the
 * authority lock and leaves grant work for the reconciler, exactly like the
 * selected-assignments dialog. Our own team's access is never touched.
 * @summary Set Host Owner
 */
export const setAdminRemoteHostOwner = async (remoteHostId: string,
    remoteHostOwnerWrite: RemoteHostOwnerWrite, options?: RequestInit): Promise<setAdminRemoteHostOwnerResponse> => {

  return orvalClient<setAdminRemoteHostOwnerResponse>(getSetAdminRemoteHostOwnerUrl(remoteHostId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteHostOwnerWrite)
  }
);}




export const getSetAdminRemoteHostOwnerMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext> => {

const mutationKey = ['setAdminRemoteHostOwner'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, {remoteHostId: string;data: RemoteHostOwnerWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  setAdminRemoteHostOwner(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetAdminRemoteHostOwnerMutationResult = NonNullable<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>>
    export type SetAdminRemoteHostOwnerMutationBody = RemoteHostOwnerWrite
    export type SetAdminRemoteHostOwnerMutationError = HTTPValidationError

    /**
 * @summary Set Host Owner
 */
export const useSetAdminRemoteHostOwner = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setAdminRemoteHostOwner>>, TError,{remoteHostId: string;data: RemoteHostOwnerWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setAdminRemoteHostOwner>>,
        TError,
        {remoteHostId: string;data: RemoteHostOwnerWrite},
        TContext
      > => {
      return useMutation(getSetAdminRemoteHostOwnerMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostStoreLabelsResponse200 = {
  data: RemoteStoreLabelsRead
  status: 200
}

export type listAdminRemoteHostStoreLabelsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listAdminRemoteHostStoreLabelsResponseSuccess = (listAdminRemoteHostStoreLabelsResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostStoreLabelsResponseError = (listAdminRemoteHostStoreLabelsResponse422) & {
  headers: Headers;
};

export type listAdminRemoteHostStoreLabelsResponse = (listAdminRemoteHostStoreLabelsResponseSuccess | listAdminRemoteHostStoreLabelsResponseError)

export const getListAdminRemoteHostStoreLabelsUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
}

/**
 * Live manual store names visible on one workstation.
 * @summary List Remote Host Store Labels
 */
export const listAdminRemoteHostStoreLabels = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostStoreLabelsResponse> => {

  return orvalClient<listAdminRemoteHostStoreLabelsResponse>(getListAdminRemoteHostStoreLabelsUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostStoreLabelsQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
    ] as const;
    }


export const getListAdminRemoteHostStoreLabelsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = HTTPValidationError>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostStoreLabelsQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>> = ({ signal }) => listAdminRemoteHostStoreLabels(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostStoreLabelsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>>
export type ListAdminRemoteHostStoreLabelsQueryError = HTTPValidationError


export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = HTTPValidationError>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Host Store Labels
 */

export function useListAdminRemoteHostStoreLabels<TData = Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStoreLabels>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostStoreLabelsQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type assignAdminRemoteHostStoreLabelResponse201 = {
  data: RemoteStoreLabelRead
  status: 201
}

export type assignAdminRemoteHostStoreLabelResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type assignAdminRemoteHostStoreLabelResponseSuccess = (assignAdminRemoteHostStoreLabelResponse201) & {
  headers: Headers;
};
export type assignAdminRemoteHostStoreLabelResponseError = (assignAdminRemoteHostStoreLabelResponse422) & {
  headers: Headers;
};

export type assignAdminRemoteHostStoreLabelResponse = (assignAdminRemoteHostStoreLabelResponseSuccess | assignAdminRemoteHostStoreLabelResponseError)

export const getAssignAdminRemoteHostStoreLabelUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels`
}

/**
 * Assign a free-form store name without creating a commerce integration.
 * @summary Assign Remote Host Store Label
 */
export const assignAdminRemoteHostStoreLabel = async (remoteHostId: string,
    remoteStoreLabelWrite: RemoteStoreLabelWrite, options?: RequestInit): Promise<assignAdminRemoteHostStoreLabelResponse> => {

  return orvalClient<assignAdminRemoteHostStoreLabelResponse>(getAssignAdminRemoteHostStoreLabelUrl(remoteHostId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteStoreLabelWrite)
  }
);}




export const getAssignAdminRemoteHostStoreLabelMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext> => {

const mutationKey = ['assignAdminRemoteHostStoreLabel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, {remoteHostId: string;data: RemoteStoreLabelWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  assignAdminRemoteHostStoreLabel(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignAdminRemoteHostStoreLabelMutationResult = NonNullable<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>>
    export type AssignAdminRemoteHostStoreLabelMutationBody = RemoteStoreLabelWrite
    export type AssignAdminRemoteHostStoreLabelMutationError = HTTPValidationError

    /**
 * @summary Assign Remote Host Store Label
 */
export const useAssignAdminRemoteHostStoreLabel = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;data: RemoteStoreLabelWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignAdminRemoteHostStoreLabel>>,
        TError,
        {remoteHostId: string;data: RemoteStoreLabelWrite},
        TContext
      > => {
      return useMutation(getAssignAdminRemoteHostStoreLabelMutationOptions(options), queryClient);
    }
    export type removeAdminRemoteHostStoreLabelResponse204 = {
  data: void
  status: 204
}

export type removeAdminRemoteHostStoreLabelResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeAdminRemoteHostStoreLabelResponseSuccess = (removeAdminRemoteHostStoreLabelResponse204) & {
  headers: Headers;
};
export type removeAdminRemoteHostStoreLabelResponseError = (removeAdminRemoteHostStoreLabelResponse422) & {
  headers: Headers;
};

export type removeAdminRemoteHostStoreLabelResponse = (removeAdminRemoteHostStoreLabelResponseSuccess | removeAdminRemoteHostStoreLabelResponseError)

export const getRemoveAdminRemoteHostStoreLabelUrl = (remoteHostId: string,
    labelId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/store-labels/${labelId}`
}

/**
 * Retire one manual store name while preserving its history.
 * @summary Remove Remote Host Store Label
 */
export const removeAdminRemoteHostStoreLabel = async (remoteHostId: string,
    labelId: string, options?: RequestInit): Promise<removeAdminRemoteHostStoreLabelResponse> => {

  return orvalClient<removeAdminRemoteHostStoreLabelResponse>(getRemoveAdminRemoteHostStoreLabelUrl(remoteHostId,labelId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveAdminRemoteHostStoreLabelMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext> => {

const mutationKey = ['removeAdminRemoteHostStoreLabel'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, {remoteHostId: string;labelId: string}> = (props) => {
          const {remoteHostId,labelId} = props ?? {};

          return  removeAdminRemoteHostStoreLabel(remoteHostId,labelId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdminRemoteHostStoreLabelMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>>

    export type RemoveAdminRemoteHostStoreLabelMutationError = HTTPValidationError

    /**
 * @summary Remove Remote Host Store Label
 */
export const useRemoveAdminRemoteHostStoreLabel = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>, TError,{remoteHostId: string;labelId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAdminRemoteHostStoreLabel>>,
        TError,
        {remoteHostId: string;labelId: string},
        TContext
      > => {
      return useMutation(getRemoveAdminRemoteHostStoreLabelMutationOptions(options), queryClient);
    }
    export type listAdminRemoteHostStoresResponse200 = {
  data: RemoteStoreLinksRead
  status: 200
}

export type listAdminRemoteHostStoresResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listAdminRemoteHostStoresResponseSuccess = (listAdminRemoteHostStoresResponse200) & {
  headers: Headers;
};
export type listAdminRemoteHostStoresResponseError = (listAdminRemoteHostStoresResponse422) & {
  headers: Headers;
};

export type listAdminRemoteHostStoresResponse = (listAdminRemoteHostStoresResponseSuccess | listAdminRemoteHostStoresResponseError)

export const getListAdminRemoteHostStoresUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
}

/**
 * Which stores this workstation is looking after.
 * @summary List Remote Host Stores
 */
export const listAdminRemoteHostStores = async (remoteHostId: string, options?: RequestInit): Promise<listAdminRemoteHostStoresResponse> => {

  return orvalClient<listAdminRemoteHostStoresResponse>(getListAdminRemoteHostStoresUrl(remoteHostId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteHostStoresQueryKey = (remoteHostId: string,) => {
    return [
    `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
    ] as const;
    }


export const getListAdminRemoteHostStoresQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = HTTPValidationError>(remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteHostStoresQueryKey(remoteHostId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteHostStores>>> = ({ signal }) => listAdminRemoteHostStores(remoteHostId, { signal });





   return  { queryKey, queryFn, enabled: remoteHostId !== null && remoteHostId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteHostStoresQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteHostStores>>>
export type ListAdminRemoteHostStoresQueryError = HTTPValidationError


export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteHostStores>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Remote Host Stores
 */

export function useListAdminRemoteHostStores<TData = Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError = HTTPValidationError>(
 remoteHostId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteHostStores>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteHostStoresQueryOptions(remoteHostId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type linkAdminRemoteHostStoreResponse201 = {
  data: RemoteStoreLinkRead
  status: 201
}

export type linkAdminRemoteHostStoreResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type linkAdminRemoteHostStoreResponseSuccess = (linkAdminRemoteHostStoreResponse201) & {
  headers: Headers;
};
export type linkAdminRemoteHostStoreResponseError = (linkAdminRemoteHostStoreResponse422) & {
  headers: Headers;
};

export type linkAdminRemoteHostStoreResponse = (linkAdminRemoteHostStoreResponseSuccess | linkAdminRemoteHostStoreResponseError)

export const getLinkAdminRemoteHostStoreUrl = (remoteHostId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores`
}

/**
 * Say that this workstation looks after one more store.
 *
 * Linking records an operational fact that was decided elsewhere. It grants
 * nobody access to anything, it opens no shop, and it prevents no one from
 * opening one — that happens in a browser inside the remote session, out of
 * this system's reach. Who may connect to the machine is still decided by
 * assignments alone.
 *
 * A store already recorded on another machine is refused here so the record
 * cannot say a shop is in two places. Moving the record is a deliberate
 * two-step — retire the old link, then make this one.
 * @summary Link Remote Host Store
 */
export const linkAdminRemoteHostStore = async (remoteHostId: string,
    remoteStoreLinkWrite: RemoteStoreLinkWrite, options?: RequestInit): Promise<linkAdminRemoteHostStoreResponse> => {

  return orvalClient<linkAdminRemoteHostStoreResponse>(getLinkAdminRemoteHostStoreUrl(remoteHostId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteStoreLinkWrite)
  }
);}




export const getLinkAdminRemoteHostStoreMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext> => {

const mutationKey = ['linkAdminRemoteHostStore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, {remoteHostId: string;data: RemoteStoreLinkWrite}> = (props) => {
          const {remoteHostId,data} = props ?? {};

          return  linkAdminRemoteHostStore(remoteHostId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LinkAdminRemoteHostStoreMutationResult = NonNullable<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>>
    export type LinkAdminRemoteHostStoreMutationBody = RemoteStoreLinkWrite
    export type LinkAdminRemoteHostStoreMutationError = HTTPValidationError

    /**
 * @summary Link Remote Host Store
 */
export const useLinkAdminRemoteHostStore = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linkAdminRemoteHostStore>>, TError,{remoteHostId: string;data: RemoteStoreLinkWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linkAdminRemoteHostStore>>,
        TError,
        {remoteHostId: string;data: RemoteStoreLinkWrite},
        TContext
      > => {
      return useMutation(getLinkAdminRemoteHostStoreMutationOptions(options), queryClient);
    }
    export type unlinkAdminRemoteHostStoreResponse204 = {
  data: void
  status: 204
}

export type unlinkAdminRemoteHostStoreResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type unlinkAdminRemoteHostStoreResponseSuccess = (unlinkAdminRemoteHostStoreResponse204) & {
  headers: Headers;
};
export type unlinkAdminRemoteHostStoreResponseError = (unlinkAdminRemoteHostStoreResponse422) & {
  headers: Headers;
};

export type unlinkAdminRemoteHostStoreResponse = (unlinkAdminRemoteHostStoreResponseSuccess | unlinkAdminRemoteHostStoreResponseError)

export const getUnlinkAdminRemoteHostStoreUrl = (remoteHostId: string,
    linkId: string,) => {




  return `/api/v1/admin/remote-access/hosts/${remoteHostId}/stores/${linkId}`
}

/**
 * Stop saying this workstation looks after that store.
 *
 * The row is retired, not deleted, so the period it was in force stays
 * readable after the fact.
 * @summary Unlink Remote Host Store
 */
export const unlinkAdminRemoteHostStore = async (remoteHostId: string,
    linkId: string, options?: RequestInit): Promise<unlinkAdminRemoteHostStoreResponse> => {

  return orvalClient<unlinkAdminRemoteHostStoreResponse>(getUnlinkAdminRemoteHostStoreUrl(remoteHostId,linkId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getUnlinkAdminRemoteHostStoreMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext> => {

const mutationKey = ['unlinkAdminRemoteHostStore'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, {remoteHostId: string;linkId: string}> = (props) => {
          const {remoteHostId,linkId} = props ?? {};

          return  unlinkAdminRemoteHostStore(remoteHostId,linkId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlinkAdminRemoteHostStoreMutationResult = NonNullable<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>>

    export type UnlinkAdminRemoteHostStoreMutationError = HTTPValidationError

    /**
 * @summary Unlink Remote Host Store
 */
export const useUnlinkAdminRemoteHostStore = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>, TError,{remoteHostId: string;linkId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof unlinkAdminRemoteHostStore>>,
        TError,
        {remoteHostId: string;linkId: string},
        TContext
      > => {
      return useMutation(getUnlinkAdminRemoteHostStoreMutationOptions(options), queryClient);
    }
    export type reconcileAdminRemoteAccessResponse200 = {
  data: RemoteReconcileResponse
  status: 200
}

export type reconcileAdminRemoteAccessResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reconcileAdminRemoteAccessResponseSuccess = (reconcileAdminRemoteAccessResponse200) & {
  headers: Headers;
};
export type reconcileAdminRemoteAccessResponseError = (reconcileAdminRemoteAccessResponse422) & {
  headers: Headers;
};

export type reconcileAdminRemoteAccessResponse = (reconcileAdminRemoteAccessResponseSuccess | reconcileAdminRemoteAccessResponseError)

export const getReconcileAdminRemoteAccessUrl = () => {




  return `/api/v1/admin/remote-access/reconcile`
}

/**
 * @summary Reconcile Remote Access
 */
export const reconcileAdminRemoteAccess = async (remoteReconcileRequest: RemoteReconcileRequest, options?: RequestInit): Promise<reconcileAdminRemoteAccessResponse> => {

  return orvalClient<reconcileAdminRemoteAccessResponse>(getReconcileAdminRemoteAccessUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteReconcileRequest)
  }
);}




export const getReconcileAdminRemoteAccessMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext> => {

const mutationKey = ['reconcileAdminRemoteAccess'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, {data: RemoteReconcileRequest}> = (props) => {
          const {data} = props ?? {};

          return  reconcileAdminRemoteAccess(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReconcileAdminRemoteAccessMutationResult = NonNullable<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>>
    export type ReconcileAdminRemoteAccessMutationBody = RemoteReconcileRequest
    export type ReconcileAdminRemoteAccessMutationError = HTTPValidationError

    /**
 * @summary Reconcile Remote Access
 */
export const useReconcileAdminRemoteAccess = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>, TError,{data: RemoteReconcileRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reconcileAdminRemoteAccess>>,
        TError,
        {data: RemoteReconcileRequest},
        TContext
      > => {
      return useMutation(getReconcileAdminRemoteAccessMutationOptions(options), queryClient);
    }
    export type listAdminRemoteSellerOrgsResponse200 = {
  data: RemoteSellerOrgsRead
  status: 200
}

export type listAdminRemoteSellerOrgsResponseSuccess = (listAdminRemoteSellerOrgsResponse200) & {
  headers: Headers;
};
;

export type listAdminRemoteSellerOrgsResponse = (listAdminRemoteSellerOrgsResponseSuccess)

export const getListAdminRemoteSellerOrgsUrl = () => {




  return `/api/v1/admin/remote-access/seller-orgs`
}

/**
 * Every active seller, for the customer-machine owner picker.
 * @summary List Seller Orgs
 */
export const listAdminRemoteSellerOrgs = async ( options?: RequestInit): Promise<listAdminRemoteSellerOrgsResponse> => {

  return orvalClient<listAdminRemoteSellerOrgsResponse>(getListAdminRemoteSellerOrgsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminRemoteSellerOrgsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/seller-orgs`
    ] as const;
    }


export const getListAdminRemoteSellerOrgsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminRemoteSellerOrgsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>> = ({ signal }) => listAdminRemoteSellerOrgs({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminRemoteSellerOrgsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>>
export type ListAdminRemoteSellerOrgsQueryError = unknown


export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>,
          TError,
          Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Seller Orgs
 */

export function useListAdminRemoteSellerOrgs<TData = Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminRemoteSellerOrgs>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminRemoteSellerOrgsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type getAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type getAdminRemoteSessionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getAdminRemoteSessionResponseSuccess = (getAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type getAdminRemoteSessionResponseError = (getAdminRemoteSessionResponse422) & {
  headers: Headers;
};

export type getAdminRemoteSessionResponse = (getAdminRemoteSessionResponseSuccess | getAdminRemoteSessionResponseError)

export const getGetAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}`
}

/**
 * @summary Get Session Status
 */
export const getAdminRemoteSession = async (sessionId: string, options?: RequestInit): Promise<getAdminRemoteSessionResponse> => {

  return orvalClient<getAdminRemoteSessionResponse>(getGetAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdminRemoteSessionQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/admin/remote-access/sessions/${sessionId}`
    ] as const;
    }


export const getGetAdminRemoteSessionQueryOptions = <TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = HTTPValidationError>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminRemoteSessionQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminRemoteSession>>> = ({ signal }) => getAdminRemoteSession(sessionId, { signal });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminRemoteSessionQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminRemoteSession>>>
export type GetAdminRemoteSessionQueryError = HTTPValidationError


export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminRemoteSession>>,
          TError,
          Awaited<ReturnType<typeof getAdminRemoteSession>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session Status
 */

export function useGetAdminRemoteSession<TData = Awaited<ReturnType<typeof getAdminRemoteSession>>, TError = HTTPValidationError>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminRemoteSession>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminRemoteSessionQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type closeAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type closeAdminRemoteSessionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type closeAdminRemoteSessionResponseSuccess = (closeAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type closeAdminRemoteSessionResponseError = (closeAdminRemoteSessionResponse422) & {
  headers: Headers;
};

export type closeAdminRemoteSessionResponse = (closeAdminRemoteSessionResponseSuccess | closeAdminRemoteSessionResponseError)

export const getCloseAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}/close`
}

/**
 * @summary Close Remote Session
 */
export const closeAdminRemoteSession = async (sessionId: string,
    remoteSessionCloseRequest: RemoteSessionCloseRequest, options?: RequestInit): Promise<closeAdminRemoteSessionResponse> => {

  return orvalClient<closeAdminRemoteSessionResponse>(getCloseAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSessionCloseRequest)
  }
);}




export const getCloseAdminRemoteSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext> => {

const mutationKey = ['closeAdminRemoteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeAdminRemoteSession>>, {sessionId: string;data: RemoteSessionCloseRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  closeAdminRemoteSession(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseAdminRemoteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof closeAdminRemoteSession>>>
    export type CloseAdminRemoteSessionMutationBody = RemoteSessionCloseRequest
    export type CloseAdminRemoteSessionMutationError = HTTPValidationError

    /**
 * @summary Close Remote Session
 */
export const useCloseAdminRemoteSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeAdminRemoteSession>>,
        TError,
        {sessionId: string;data: RemoteSessionCloseRequest},
        TContext
      > => {
      return useMutation(getCloseAdminRemoteSessionMutationOptions(options), queryClient);
    }
    export type closeOwnedAdminRemoteSessionResponse200 = {
  data: RemoteSessionRead
  status: 200
}

export type closeOwnedAdminRemoteSessionResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type closeOwnedAdminRemoteSessionResponseSuccess = (closeOwnedAdminRemoteSessionResponse200) & {
  headers: Headers;
};
export type closeOwnedAdminRemoteSessionResponseError = (closeOwnedAdminRemoteSessionResponse422) & {
  headers: Headers;
};

export type closeOwnedAdminRemoteSessionResponse = (closeOwnedAdminRemoteSessionResponseSuccess | closeOwnedAdminRemoteSessionResponseError)

export const getCloseOwnedAdminRemoteSessionUrl = (sessionId: string,) => {




  return `/api/v1/admin/remote-access/sessions/${sessionId}/close-owned`
}

/**
 * Terminate an owned lease without acquiring its historical login authority.
 * @summary Close Owned Remote Session
 */
export const closeOwnedAdminRemoteSession = async (sessionId: string,
    remoteSessionCloseRequest: RemoteSessionCloseRequest, options?: RequestInit): Promise<closeOwnedAdminRemoteSessionResponse> => {

  return orvalClient<closeOwnedAdminRemoteSessionResponse>(getCloseOwnedAdminRemoteSessionUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteSessionCloseRequest)
  }
);}




export const getCloseOwnedAdminRemoteSessionMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext> => {

const mutationKey = ['closeOwnedAdminRemoteSession'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, {sessionId: string;data: RemoteSessionCloseRequest}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  closeOwnedAdminRemoteSession(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CloseOwnedAdminRemoteSessionMutationResult = NonNullable<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>>
    export type CloseOwnedAdminRemoteSessionMutationBody = RemoteSessionCloseRequest
    export type CloseOwnedAdminRemoteSessionMutationError = HTTPValidationError

    /**
 * @summary Close Owned Remote Session
 */
export const useCloseOwnedAdminRemoteSession = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>, TError,{sessionId: string;data: RemoteSessionCloseRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof closeOwnedAdminRemoteSession>>,
        TError,
        {sessionId: string;data: RemoteSessionCloseRequest},
        TContext
      > => {
      return useMutation(getCloseOwnedAdminRemoteSessionMutationOptions(options), queryClient);
    }
    export type listAdminStoreProductGroupsResponse200 = {
  data: StoreProductGroupsRead
  status: 200
}

export type listAdminStoreProductGroupsResponseSuccess = (listAdminStoreProductGroupsResponse200) & {
  headers: Headers;
};
;

export type listAdminStoreProductGroupsResponse = (listAdminStoreProductGroupsResponseSuccess)

export const getListAdminStoreProductGroupsUrl = () => {




  return `/api/v1/admin/remote-access/store-product-groups`
}

/**
 * Every internal (BO1) store with its live product-group tags, in one read.
 *
 * Independent of the remote-access pilot rollout: this reads store assortment,
 * not machine assignment, so every admin with remote_access.view sees every
 * internal store here regardless of which (if any) machine looks after it.
 * @summary List Store Product Groups
 */
export const listAdminStoreProductGroups = async ( options?: RequestInit): Promise<listAdminStoreProductGroupsResponse> => {

  return orvalClient<listAdminStoreProductGroupsResponse>(getListAdminStoreProductGroupsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdminStoreProductGroupsQueryKey = () => {
    return [
    `/api/v1/admin/remote-access/store-product-groups`
    ] as const;
    }


export const getListAdminStoreProductGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdminStoreProductGroupsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdminStoreProductGroups>>> = ({ signal }) => listAdminStoreProductGroups({ signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdminStoreProductGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listAdminStoreProductGroups>>>
export type ListAdminStoreProductGroupsQueryError = unknown


export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>,
          TError,
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>,
          TError,
          Awaited<ReturnType<typeof listAdminStoreProductGroups>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Store Product Groups
 */

export function useListAdminStoreProductGroups<TData = Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdminStoreProductGroups>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdminStoreProductGroupsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type assignAdminStoreProductGroupResponse201 = {
  data: StoreProductGroupRead
  status: 201
}

export type assignAdminStoreProductGroupResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type assignAdminStoreProductGroupResponseSuccess = (assignAdminStoreProductGroupResponse201) & {
  headers: Headers;
};
export type assignAdminStoreProductGroupResponseError = (assignAdminStoreProductGroupResponse422) & {
  headers: Headers;
};

export type assignAdminStoreProductGroupResponse = (assignAdminStoreProductGroupResponseSuccess | assignAdminStoreProductGroupResponseError)

export const getAssignAdminStoreProductGroupUrl = () => {




  return `/api/v1/admin/remote-access/store-product-groups`
}

/**
 * Tag one internal store with a product group it sells.
 * @summary Assign Store Product Group
 */
export const assignAdminStoreProductGroup = async (storeProductGroupWrite: StoreProductGroupWrite, options?: RequestInit): Promise<assignAdminStoreProductGroupResponse> => {

  return orvalClient<assignAdminStoreProductGroupResponse>(getAssignAdminStoreProductGroupUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(storeProductGroupWrite)
  }
);}




export const getAssignAdminStoreProductGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext> => {

const mutationKey = ['assignAdminStoreProductGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, {data: StoreProductGroupWrite}> = (props) => {
          const {data} = props ?? {};

          return  assignAdminStoreProductGroup(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignAdminStoreProductGroupMutationResult = NonNullable<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>>
    export type AssignAdminStoreProductGroupMutationBody = StoreProductGroupWrite
    export type AssignAdminStoreProductGroupMutationError = HTTPValidationError

    /**
 * @summary Assign Store Product Group
 */
export const useAssignAdminStoreProductGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignAdminStoreProductGroup>>, TError,{data: StoreProductGroupWrite}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof assignAdminStoreProductGroup>>,
        TError,
        {data: StoreProductGroupWrite},
        TContext
      > => {
      return useMutation(getAssignAdminStoreProductGroupMutationOptions(options), queryClient);
    }
    export type removeAdminStoreProductGroupResponse204 = {
  data: void
  status: 204
}

export type removeAdminStoreProductGroupResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeAdminStoreProductGroupResponseSuccess = (removeAdminStoreProductGroupResponse204) & {
  headers: Headers;
};
export type removeAdminStoreProductGroupResponseError = (removeAdminStoreProductGroupResponse422) & {
  headers: Headers;
};

export type removeAdminStoreProductGroupResponse = (removeAdminStoreProductGroupResponseSuccess | removeAdminStoreProductGroupResponseError)

export const getRemoveAdminStoreProductGroupUrl = (groupId: string,) => {




  return `/api/v1/admin/remote-access/store-product-groups/${groupId}`
}

/**
 * Retire one product-group tag while preserving its history.
 * @summary Remove Store Product Group
 */
export const removeAdminStoreProductGroup = async (groupId: string, options?: RequestInit): Promise<removeAdminStoreProductGroupResponse> => {

  return orvalClient<removeAdminStoreProductGroupResponse>(getRemoveAdminStoreProductGroupUrl(groupId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemoveAdminStoreProductGroupMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext> => {

const mutationKey = ['removeAdminStoreProductGroup'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, {groupId: string}> = (props) => {
          const {groupId} = props ?? {};

          return  removeAdminStoreProductGroup(groupId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveAdminStoreProductGroupMutationResult = NonNullable<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>>

    export type RemoveAdminStoreProductGroupMutationError = HTTPValidationError

    /**
 * @summary Remove Store Product Group
 */
export const useRemoveAdminStoreProductGroup = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeAdminStoreProductGroup>>, TError,{groupId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeAdminStoreProductGroup>>,
        TError,
        {groupId: string},
        TContext
      > => {
      return useMutation(getRemoveAdminStoreProductGroupMutationOptions(options), queryClient);
    }
    export type reportRemoteGatewayResultResponse200 = {
  data: RemoteGatewayResultAck
  status: 200
}

export type reportRemoteGatewayResultResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type reportRemoteGatewayResultResponseSuccess = (reportRemoteGatewayResultResponse200) & {
  headers: Headers;
};
export type reportRemoteGatewayResultResponseError = (reportRemoteGatewayResultResponse422) & {
  headers: Headers;
};

export type reportRemoteGatewayResultResponse = (reportRemoteGatewayResultResponseSuccess | reportRemoteGatewayResultResponseError)

export const getReportRemoteGatewayResultUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/gateway-result`
}

/**
 * @summary Report Gateway Result
 */
export const reportRemoteGatewayResult = async (sessionId: string,
    remoteGatewayResultReport: RemoteGatewayResultReport, options?: RequestInit): Promise<reportRemoteGatewayResultResponse> => {

  return orvalClient<reportRemoteGatewayResultResponse>(getReportRemoteGatewayResultUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteGatewayResultReport)
  }
);}




export const getReportRemoteGatewayResultMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext> => {

const mutationKey = ['reportRemoteGatewayResult'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, {sessionId: string;data: RemoteGatewayResultReport}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  reportRemoteGatewayResult(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReportRemoteGatewayResultMutationResult = NonNullable<Awaited<ReturnType<typeof reportRemoteGatewayResult>>>
    export type ReportRemoteGatewayResultMutationBody = RemoteGatewayResultReport
    export type ReportRemoteGatewayResultMutationError = HTTPValidationError

    /**
 * @summary Report Gateway Result
 */
export const useReportRemoteGatewayResult = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reportRemoteGatewayResult>>, TError,{sessionId: string;data: RemoteGatewayResultReport}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reportRemoteGatewayResult>>,
        TError,
        {sessionId: string;data: RemoteGatewayResultReport},
        TContext
      > => {
      return useMutation(getReportRemoteGatewayResultMutationOptions(options), queryClient);
    }
    export type getRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverWarning | null
  status: 200
}

export type getRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type getRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type getRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type getRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type getRemoteSessionTakeoverResponseSuccess = (getRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type getRemoteSessionTakeoverResponseError = (getRemoteSessionTakeoverResponse401 | getRemoteSessionTakeoverResponse404 | getRemoteSessionTakeoverResponse409 | getRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type getRemoteSessionTakeoverResponse = (getRemoteSessionTakeoverResponseSuccess | getRemoteSessionTakeoverResponseError)

export const getGetRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover`
}

/**
 * @summary Get Session Takeover
 */
export const getRemoteSessionTakeover = async (sessionId: string, options?: RequestInit): Promise<getRemoteSessionTakeoverResponse> => {

  return orvalClient<getRemoteSessionTakeoverResponse>(getGetRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRemoteSessionTakeoverQueryKey = (sessionId: string,) => {
    return [
    `/api/v1/internal/remote-access/sessions/${sessionId}/takeover`
    ] as const;
    }


export const getGetRemoteSessionTakeoverQueryOptions = <TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRemoteSessionTakeoverQueryKey(sessionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRemoteSessionTakeover>>> = ({ signal }) => getRemoteSessionTakeover(sessionId, { signal });





   return  { queryKey, queryFn, enabled: sessionId !== null && sessionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRemoteSessionTakeoverQueryResult = NonNullable<Awaited<ReturnType<typeof getRemoteSessionTakeover>>>
export type GetRemoteSessionTakeoverQueryError = RemoteAccessErrorResponse


export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>,
          TError,
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>,
          TError,
          Awaited<ReturnType<typeof getRemoteSessionTakeover>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Session Takeover
 */

export function useGetRemoteSessionTakeover<TData = Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError = RemoteAccessErrorResponse>(
 sessionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRemoteSessionTakeover>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetRemoteSessionTakeoverQueryOptions(sessionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export type handOverRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverDecisionAck
  status: 200
}

export type handOverRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type handOverRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type handOverRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type handOverRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type handOverRemoteSessionTakeoverResponseSuccess = (handOverRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type handOverRemoteSessionTakeoverResponseError = (handOverRemoteSessionTakeoverResponse401 | handOverRemoteSessionTakeoverResponse404 | handOverRemoteSessionTakeoverResponse409 | handOverRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type handOverRemoteSessionTakeoverResponse = (handOverRemoteSessionTakeoverResponseSuccess | handOverRemoteSessionTakeoverResponseError)

export const getHandOverRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover/hand-over-now`
}

/**
 * @summary Hand Over Session Takeover
 */
export const handOverRemoteSessionTakeover = async (sessionId: string,
    remoteTakeoverOperatorDecision: RemoteTakeoverOperatorDecision, options?: RequestInit): Promise<handOverRemoteSessionTakeoverResponse> => {

  return orvalClient<handOverRemoteSessionTakeoverResponse>(getHandOverRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverOperatorDecision)
  }
);}




export const getHandOverRemoteSessionTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext> => {

const mutationKey = ['handOverRemoteSessionTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, {sessionId: string;data: RemoteTakeoverOperatorDecision}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  handOverRemoteSessionTakeover(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HandOverRemoteSessionTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>>
    export type HandOverRemoteSessionTakeoverMutationBody = RemoteTakeoverOperatorDecision
    export type HandOverRemoteSessionTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Hand Over Session Takeover
 */
export const useHandOverRemoteSessionTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorDecision}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof handOverRemoteSessionTakeover>>,
        TError,
        {sessionId: string;data: RemoteTakeoverOperatorDecision},
        TContext
      > => {
      return useMutation(getHandOverRemoteSessionTakeoverMutationOptions(options), queryClient);
    }
    export type rejectRemoteSessionTakeoverResponse200 = {
  data: RemoteTakeoverDecisionAck
  status: 200
}

export type rejectRemoteSessionTakeoverResponse401 = {
  data: RemoteAccessErrorResponse
  status: 401
}

export type rejectRemoteSessionTakeoverResponse404 = {
  data: RemoteAccessErrorResponse
  status: 404
}

export type rejectRemoteSessionTakeoverResponse409 = {
  data: RemoteAccessErrorResponse
  status: 409
}

export type rejectRemoteSessionTakeoverResponse422 = {
  data: RemoteAccessErrorResponse
  status: 422
}

export type rejectRemoteSessionTakeoverResponseSuccess = (rejectRemoteSessionTakeoverResponse200) & {
  headers: Headers;
};
export type rejectRemoteSessionTakeoverResponseError = (rejectRemoteSessionTakeoverResponse401 | rejectRemoteSessionTakeoverResponse404 | rejectRemoteSessionTakeoverResponse409 | rejectRemoteSessionTakeoverResponse422) & {
  headers: Headers;
};

export type rejectRemoteSessionTakeoverResponse = (rejectRemoteSessionTakeoverResponseSuccess | rejectRemoteSessionTakeoverResponseError)

export const getRejectRemoteSessionTakeoverUrl = (sessionId: string,) => {




  return `/api/v1/internal/remote-access/sessions/${sessionId}/takeover/reject`
}

/**
 * @summary Reject Session Takeover
 */
export const rejectRemoteSessionTakeover = async (sessionId: string,
    remoteTakeoverOperatorReject: RemoteTakeoverOperatorReject, options?: RequestInit): Promise<rejectRemoteSessionTakeoverResponse> => {

  return orvalClient<rejectRemoteSessionTakeoverResponse>(getRejectRemoteSessionTakeoverUrl(sessionId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteTakeoverOperatorReject)
  }
);}




export const getRejectRemoteSessionTakeoverMutationOptions = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext> => {

const mutationKey = ['rejectRemoteSessionTakeover'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, {sessionId: string;data: RemoteTakeoverOperatorReject}> = (props) => {
          const {sessionId,data} = props ?? {};

          return  rejectRemoteSessionTakeover(sessionId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectRemoteSessionTakeoverMutationResult = NonNullable<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>>
    export type RejectRemoteSessionTakeoverMutationBody = RemoteTakeoverOperatorReject
    export type RejectRemoteSessionTakeoverMutationError = RemoteAccessErrorResponse

    /**
 * @summary Reject Session Takeover
 */
export const useRejectRemoteSessionTakeover = <TError = RemoteAccessErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>, TError,{sessionId: string;data: RemoteTakeoverOperatorReject}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectRemoteSessionTakeover>>,
        TError,
        {sessionId: string;data: RemoteTakeoverOperatorReject},
        TContext
      > => {
      return useMutation(getRejectRemoteSessionTakeoverMutationOptions(options), queryClient);
    }
    export type consumeRemoteLaunchTicketResponse200 = {
  data: RemoteLaunchTicketConsumeResponse
  status: 200
}

export type consumeRemoteLaunchTicketResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type consumeRemoteLaunchTicketResponseSuccess = (consumeRemoteLaunchTicketResponse200) & {
  headers: Headers;
};
export type consumeRemoteLaunchTicketResponseError = (consumeRemoteLaunchTicketResponse422) & {
  headers: Headers;
};

export type consumeRemoteLaunchTicketResponse = (consumeRemoteLaunchTicketResponseSuccess | consumeRemoteLaunchTicketResponseError)

export const getConsumeRemoteLaunchTicketUrl = () => {




  return `/api/v1/internal/remote-access/tickets/consume`
}

/**
 * @summary Consume Ticket
 */
export const consumeRemoteLaunchTicket = async (remoteLaunchTicketConsumeRequest: RemoteLaunchTicketConsumeRequest, options?: RequestInit): Promise<consumeRemoteLaunchTicketResponse> => {

  return orvalClient<consumeRemoteLaunchTicketResponse>(getConsumeRemoteLaunchTicketUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(remoteLaunchTicketConsumeRequest)
  }
);}




export const getConsumeRemoteLaunchTicketMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext> => {

const mutationKey = ['consumeRemoteLaunchTicket'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, {data: RemoteLaunchTicketConsumeRequest}> = (props) => {
          const {data} = props ?? {};

          return  consumeRemoteLaunchTicket(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConsumeRemoteLaunchTicketMutationResult = NonNullable<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>>
    export type ConsumeRemoteLaunchTicketMutationBody = RemoteLaunchTicketConsumeRequest
    export type ConsumeRemoteLaunchTicketMutationError = HTTPValidationError

    /**
 * @summary Consume Ticket
 */
export const useConsumeRemoteLaunchTicket = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>, TError,{data: RemoteLaunchTicketConsumeRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof consumeRemoteLaunchTicket>>,
        TError,
        {data: RemoteLaunchTicketConsumeRequest},
        TContext
      > => {
      return useMutation(getConsumeRemoteLaunchTicketMutationOptions(options), queryClient);
    }
